import { useState } from "react";
import CustomArea from "../../shared/CustomArea";
import CustomInput from "../../shared/CustomInput";
import EditRoleModal from "./EditRoleModal";

const EditRoleInformation = ({
  closeRoleModal,
  activeIndex,
  handleNextStep,
  finishText,
  loading,
  myRole,
  setMyRole,
}) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!myRole.roleName?.trim()) {
      newErrors.roleName = "Role name is required";
    }
    if (!myRole.roleDescription?.trim()) {
      newErrors.roleDescription = "Role description is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onNext = () => {
    if (validate()) {
      handleNextStep();
    }
  };
  return (
    <EditRoleModal
      closeRoleModal={closeRoleModal}
      activeIndex={activeIndex}
      handleNextStep={onNext}
      finishText={finishText}
      loading={loading}
    >
      <div>
        <p className="font-medium text-[15px] text-[#222222]">
          Create a new role
        </p>
        <p className="text-[#000000] font-semibold text-[20px]">
          Role Information
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal">
          Create a new role and specify its permissions to ensure precise access
          control.
        </p>
        <div className="my-[20px] w-full">
          <div className="flex w-[95%] mb-[20px] flex-col">
            <label
              className="text-[#222222] font-medium text-[13px]"
              htmlFor="Role name"
            >
              Role name
            </label>
            <CustomInput
              placeholder="Enter role name"
              type="text"
              value={myRole?.roleName}
              onChange={(e) =>
                setMyRole({ ...myRole, roleName: e.target.value })
              }
            />
            {errors.roleName && (
              <p className="text-red-500 text-sm mt-1">{errors.roleName}</p>
            )}
          </div>
          <div className="flex w-[95%] flex-col">
            <label
              className="text-[#222222] font-medium text-[13px]"
              htmlFor="Role description"
            >
              Role description
            </label>
            <CustomArea
              placeholder="Enter role description"
              type="text"
              value={myRole?.roleDescription}
              onChange={(e) =>
                setMyRole({ ...myRole, roleDescription: e.target.value })
              }
            />
            {errors.roleDescription && (
              <p className="text-red-500 text-sm mt-1">
                {errors.roleDescription}
              </p>
            )}
          </div>
        </div>
      </div>
    </EditRoleModal>
  );
};

export default EditRoleInformation;
